module.exports = __webpack_public_path__ + "img/guide-student2.45b862ae.png";